import React from "react";
import { withRouter } from "react-router";
import { Button } from "antd";

const QuickLinks = props => {
  const queryRecentFilings = { pathname: props.router.location.pathname, query: { sort: "-filing_date" } };
  const queryRecentInstitutions = { pathname: props.router.location.pathname, query: { sort: "-up_institution_date" } };
  const queryRecentTerminations = { pathname: props.router.location.pathname, query: { sort: "-up_termination_date" } };
  const queryUnified = { pathname: props.router.location.pathname, query: { petitioners: "Unified Patents", sort: "-filing_date" } };
  return (
    <div>
      <Button type="link" size="small" onClick={() => props.router.push(queryRecentFilings)}>
        {"Recent Filings"}
      </Button>
      <Button type="link" size="small" onClick={() => props.router.push(queryRecentInstitutions)}>
        {"Recent Institutions"}
      </Button>
      <Button type="link" size="small" onClick={() => props.router.push(queryRecentTerminations)}>
        {"Recent Terminations"}
      </Button>
      <Button type="link" size="small" onClick={() => props.router.push(queryUnified)}>
        {"Filed by Unified Patents"}
      </Button>
    </div>
  );
};

export default withRouter(QuickLinks);
